import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
// utils
import { fToNow } from 'src/utils/format-time';
// components
import Label from 'src/components/label';
import FileThumbnail from 'src/components/file-thumbnail';
import { useMarkAsReadMutation } from 'src/store/Reducer/notification';

// ----------------------------------------------------------------------

export default function NotificationItem({ notification ,onClick  }) {
  
   const [markAsRead] = useMarkAsReadMutation();
   
   const handleMarkAsRead = async () => {
    try {
       const data= {notification_ids : [notification?.id ]}
      await markAsRead(data).unwrap();
      notification.is_read = '1';
    } catch (error) {
      console.error('Failed to mark as read:', error);
    }
  };


  const renderAvatar = (
    <ListItemAvatar>
        <Avatar src={notification?.sender_image} sx={{ bgcolor: 'background.neutral' }}> 
          {notification?.sender_name?.trim()?.charAt(0)?.toUpperCase()}
        </Avatar>
    </ListItemAvatar>
  );

  const renderText = (
    <ListItemText
      disableTypography
      primary={reader(notification?.message)}
      secondary={
        <Stack
          direction="row"
          alignItems="center"
          sx={{ typography: 'caption', color: 'text.disabled' }}
          divider={
            <Box
              sx={{
                width: 2,
                height: 2,
                bgcolor: 'currentColor',
                mx: 0.5,
                borderRadius: '50%',
              }}
            />
          }
        >
          {notification?.created_at}
        </Stack>
      }
    />
  );

  const renderUnReadBadge = notification?.is_read == "0"  && (
    <Box
      sx={{
        top: 26,
        width: 8,
        height: 8,
        right: 13,
        borderRadius: '50%',
        bgcolor: 'info.main',
        position: 'absolute',
      }}
    />
  );



  return (
    <ListItemButton
      disableRipple
      sx={{
        p: 2.5,
        alignItems: 'flex-start',
        borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,
      }}
       onClick={() => {
      if (notification?.is_read === "0") {
        handleMarkAsRead();
      }
      onClick?.(notification);
    }}
    >
      {renderUnReadBadge}

      {renderAvatar}

      <Stack sx={{ flexGrow: 1 }}>
        {renderText}
      </Stack>
    </ListItemButton>
  );
}

NotificationItem.propTypes = {
  notification: PropTypes.object,
};

// ----------------------------------------------------------------------

function reader(data) {
  return (
    <Box
      dangerouslySetInnerHTML={{ __html: data }}
      sx={{
        mb: 0.5,
         fontSize: '12px', 
        '& p': { typography: 'body2', m: 0 },
        '& a': { color: 'inherit', textDecoration: 'none' },
        '& strong': { typography: 'subtitle2' },
      }}
    />
  );
}